import { Stack, Typography } from '@mui/material';
import { PlanCard } from './plan';
import type { Plan } from '@/data/idp/plans/interfaces';
import { formatDate } from '@/utils/format-date';

export const ClosedPlanCard = ({ plan }: { plan: Plan }) => {
  const hasStartAndEndDates = plan?.started_at && plan?.ended_at;

  return (
    <PlanCard cardActionLabel="Ver plano" plan={plan}>
      <Stack spacing={0}>
        <Typography>
          {(plan?.duration_in_months && `${plan?.duration_in_months} meses`) ||
            'Sem duração'}
        </Typography>
        {hasStartAndEndDates && (
          <Typography>
            {formatDate(plan?.started_at || '')} -{' '}
            {formatDate(plan?.ended_at || '')}
          </Typography>
        )}
      </Stack>
    </PlanCard>
  );
};
